import {
  useCurrentSpaceContext,
  usePunditUserContext,
} from "@circle-react/contexts";

export const useIsLockedSpace = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { data: space } = useCurrentSpaceContext();
  const isPrivate = !!space?.is_private;
  const isSpaceMember = !!space?.is_space_member;
  const isAdmin = !!currentCommunityMember?.is_admin;

  return isPrivate && !isSpaceMember && !isAdmin;
};
